import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import {
  approve_order,
  create_invoice,
  get_creditDebitNote,
  get_orders,
  view_OrderDetails,
} from "./userOrdersAPI";

const initialState = {
  loading: false,
  ordersList: [],
  order_details: [],
  creditDebitNote: {},
  create_invoice_loading: false,
  creditDebitNote_loading: false,
};
const actions = {
  GETORDERS: "getOrders/GETORDERS",
  VIEWORDERDETAILS: "getOrderDetails/VIEWORDERDETAILS",
  APPROVEORDER: "approveOrder/APPROVEORDER",
  CREATEINVOICE: "createInvoice/CREATEINVOICE",
  GETCREDITDEBITNOTE: "getCreditDebitNote/GETCREDITDEBITNOTE",
};

export const getOrders = createAsyncThunk(
  actions.GETORDERS,
  async (payload) => {
    const response = await get_orders(
      payload?.page,
      payload?.rowsPerPage,
      payload?.search
    );
    return response;
  }
);

export const getOrderDetails = createAsyncThunk(
  actions.VIEWORDERDETAILS,
  async (payload) => {
    const response = await view_OrderDetails(payload);
    return response;
  }
);

export const approveOrder = createAsyncThunk(
  actions.APPROVEORDER,
  async (payload) => {
    const response = await approve_order(payload);
    return response;
  }
);
export const createInvoice = createAsyncThunk(
  actions.CREATEINVOICE,
  async (payload) => {
    const response = await create_invoice(payload);
    return response;
  }
);
export const getCreditDebitNote = createAsyncThunk(
  actions.GETCREDITDEBITNOTE,
  async (payload) => {
    const response = await get_creditDebitNote(payload);
    return response;
  }
);
export const userOrdersSlice = createSlice({
  name: "userOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.ordersList = data;

        if (success) {
          /* message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getOrders.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(getOrderDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;
        state.loading = false;
        state.order_details = data;
        if (success) {
          /*  message.success(msg); */
        } else {
          message.error(msg);
        }
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });

    builder
      .addCase(approveOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(approveOrder.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(approveOrder.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(createInvoice.pending, (state) => {
        state.create_invoice_loading = true;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.create_invoice_loading = false;
        if (success) {
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(createInvoice.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.create_invoice_loading = false;

        message.error(msg);
      });
    builder
      .addCase(getCreditDebitNote.pending, (state) => {
        state.creditDebitNote_loading = true;
      })
      .addCase(getCreditDebitNote.fulfilled, (state, action) => {
        const { success, message: msg, data } = action.payload;

        state.creditDebitNote = data;
        state.creditDebitNote_loading = false;
        if (success) {
          // message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(getCreditDebitNote.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.creditDebitNote_loading = false;
        message.error(msg);
      });
  },
});
export const userOrdersActions = userOrdersSlice.actions;
export const { resetuserOrdersDetails } = userOrdersSlice.actions;

export default userOrdersSlice.reducer;
